import { Box, Button, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import React from 'react'
import Divider from '@mui/material/Divider'
import TrashIcon from '../../../../../assests/icons/trash.svg'
import CustomAlertPopOver from '../../../../shared/Elements/AlertPopover'
import Pills from '../../../../../assests/icons/pills.svg'


const isAnyKeyNotEmpty = (obj) => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && obj['name']) {
            return true // If any key has a non-empty value, return true
        }
    }
    return false // If all keys are empty, return false
}
function IntakeForm({
   
    medications,
    setMedications
}) {
   

    const [anchorEl, setAnchorEl] = React.useState(null)
    const [selectedItemIndex, setSelectedItemIndex] = React.useState(null)

    const isAtLeastOneKeyFilled = () => {
        for (const obj of medications) {
            let hasNonEmptyKey = false
            for (const key in obj) {
                if (obj.hasOwnProperty(key) && obj['name'] !== '') {
                    hasNonEmptyKey = true // If any key is not empty, set hasNonEmptyKey to true
                    break // No need to continue checking other keys once a non-empty key is found
                }
            }
            if (!hasNonEmptyKey) {
                return false // If all keys are empty in the current object, return false
            }
        }
        return true // If at least one object has at least one non-empty key, return true
    }
    const handleInputChange = (event, index) => {
        const { name, value } = event.target
        const updatedMedicationsData = [...medications]
        updatedMedicationsData[index] = {
            ...updatedMedicationsData[index],
            [name]: value,
        }
        setMedications(updatedMedicationsData)
    }
    const handleClickDeleteIcon = (event, index) => {
        setAnchorEl(event.currentTarget)
        setSelectedItemIndex(index)
    }
    const handleDeleteMedication = () => {
        if (selectedItemIndex !== null) {
            if (medications?.length > 3 && !(selectedItemIndex >= 0 && selectedItemIndex <= 2)) {
                const updatedItems = medications.filter((_, i) => i !== selectedItemIndex)
                setMedications(updatedItems)
            } else {
                const updatedMedicationsData = [...medications]
                updatedMedicationsData[selectedItemIndex] = {
                    name: '',
                    strength: '',
                    directions: '',
                }
                setMedications(updatedMedicationsData)
            }
        }
        setSelectedItemIndex(null)
        setAnchorEl(null)
    }
    const handleAddMedication = (event) => {
        event.preventDefault()
        if (isAtLeastOneKeyFilled()) {
            setMedications((prev) => [
                ...prev,
                {
                    name: '',
                    strength: '',
                    directions: '',
                },
            ])
        }
    }
    return (
        <div className="booking_boxes intake_form_box">
            <div className="heading_holder">
                <Typography className="step-headers">
                    What medications are you currently taking?
                </Typography>
            </div>
            <Typography className="step-subheaders">You may list any prescription or over-the-counter medications you are currently taking. Leave blank if none or if you prefer not to share</Typography>
            <div className="body" style={{ marginTop: 20 }}>
                <Box className="medication_card">
                    <Box className="medication-container">
                        {medications?.map((med, index) => (
                            <Grid container direction="column" style={{ gap: '10px' }} key={index}>
                                <div className="d-md-none">
                                    <img src={Pills} style={{ marginRight: '5px' }} />
                                    <span className="medication-ser">Medication {index + 1}</span>
                                </div>
                                <div className="each_box_holder">
                                    <div className="each_holder">
                                        <p className="cstm_label_holder d-lg-none">
                                            Medication {index + 1}
                                        </p>
                                        <TextField
                                            variant="outlined"
                                            placeholder="Enter medication name"
                                            style={{ width: '100%' }}
                                            value={med?.name}
                                            name="name"
                                            onChange={(event) => handleInputChange(event, index)}
                                        />
                                    </div>
                                    <div className="each_holder">
                                        <p className="cstm_label_holder d-lg-none">Strength</p>
                                        <TextField
                                            variant="outlined"
                                            placeholder="Enter strength"
                                            style={{ width: '100%' }}
                                            value={med?.strength}
                                            name="strength"
                                            onChange={(event) => handleInputChange(event, index)}
                                        />
                                    </div>
                                    <div className="each_holder">
                                        <p className="cstm_label_holder d-lg-none">Directions</p>
                                        <TextField
                                            variant="outlined"
                                            placeholder="Enter directions"
                                            style={{ width: '100%' }}
                                            value={med?.directions}
                                            name="directions"
                                            onChange={(event) => handleInputChange(event, index)}
                                        />
                                    </div>
                                    <div
                                        className="icon_position"
                                        style={{
                                            width: '3%',
                                            opacity: isAnyKeyNotEmpty(med) ? 1 : 0.5,
                                        }}>
                                        <Box display="flex" alignItems={'center'}>
                                            <Divider
                                                orientation="vertical"
                                                variant="middle"
                                                className="divider_height d-md-none"
                                                flexItem
                                            />
                                            <div
                                                className="delete_icon"
                                                style={{
                                                    cursor: isAnyKeyNotEmpty(med)
                                                        ? 'pointer'
                                                        : 'none',
                                                }}
                                                onClick={(event) => {
                                                    isAnyKeyNotEmpty(med) &&
                                                        handleClickDeleteIcon(event, index)
                                                }}>
                                                {' '}
                                                <img src={TrashIcon} />
                                                <span className="cstm_label d-lg-none">
                                                    Remove medication {index + 1}
                                                </span>
                                            </div>
                                        </Box>
                                    </div>
                                </div>
                            </Grid>
                        ))}
                        <CustomAlertPopOver
                            anchorEl={anchorEl}
                            handleClose={() => {
                                setAnchorEl(null)
                                setSelectedItemIndex(null)
                            }}
                            title="Delete Medication"
                            bodyText={`Are you sure you want to delete the medication?`}
                            confirmButtonName={'Delete'}
                            confirmButtonColor={'red'}
                            onSuccess={handleDeleteMedication}
                        />
                    </Box>

                    <Button
                        className="add-medication-submit"
                        onClick={handleAddMedication}
                        disabled={!isAtLeastOneKeyFilled()}>
                        + Add medication
                    </Button>
                </Box>
            </div>
        </div>
    )
}

export default IntakeForm
